/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuWorkerDocsClosePartialUpdateRequest = {} | null | undefined;
export type SvuWorkerDocsClosePartialUpdateResponse = any;

export type SvuWorkerDocsClosePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/close/
 *
 * ```yaml
 * operationId: svu_worker_docs_close_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsClosePartialUpdateOperation = ({
  id,
  ...rest
}: SvuWorkerDocsClosePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_worker_docs/${id}/close/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_worker_docs/{id}/close/' };
  };

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/close/
 *
 * ```yaml
 * operationId: svu_worker_docs_close_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsClosePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuWorkerDocsClosePartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuWorkerDocsClosePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
